module.exports = __webpack_public_path__ + "static/media/college.64000c05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/OrganizationalUnit/college.svg
// module id = 2411
// module chunks = 0